import React from 'react'
import PropTypes from "prop-types"
import moment from 'moment'
import { connect } from 'react-redux'
import { keys, get, find, isObject, isArray, isBoolean, isEqual, isString } from 'lodash'
import { Panel } from 'react-bootstrap'
import { create as createJsonDiff } from 'jsondiffpatch'

import { getText, getTextWithTokens } from  '../lib/text'
import { getPropTranslation, renderModification, renderSeparator } from './LogTools.jsx'
import propsBlackList from "./propsBlackList"

import Change from './Change'

const LogViewerProps = {
  log: PropTypes.any.isRequired,
  compact: PropTypes.bool.isRequired,

  Cities: PropTypes.object.isRequired,
  Activities: PropTypes.object.isRequired,
  routes: PropTypes.object.isRequired,
  trip: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
}

// #WARNING *maybe* should use getNameOrTitle or sthg?
// no es trivial. rutas no tienen title.
function getDocumentName(doc) {
  return doc.name || doc.realName || `[sin nombre (${doc._id})]`
}

/**
 *
 */

class LogViewer extends React.PureComponent
{
  constructor(props) {
    super(props)

    this.state = {}

    this.jsonDiffInstance = createJsonDiff({
      objectHash: obj => (obj.key || obj._id || obj.id)
    })
  }

  props: LogViewerProps

  renderEntry(doc, entry, entryIdx, log, Activities, Cities, jsonDiffInstance) {

    const isFirstEntry = entryIdx == 0

    // previous entry of same collection
    // #TODO shouldnt need to check type
    // (se hacía porque los "c" no tienen changes, pero el código probablemente funcione asumiendo changes vacíos)
    // (o debería ¬¬, en el caso de dato escalar (ni objeto ni array) no lo hace)
    const previous = find(
      log,
      e => e.col == entry.col && e.type == entry.type && e.id == entry.id,
      entryIdx + 1
    )

    const separador = (
      (isFirstEntry || !moment(entry.timestamp).isSame(log[entryIdx - 1].timestamp, 'day'))
        ? renderSeparator(entry.timestamp)
        : null
    )

    let renderedEntry = null

    const Box = this.props.compact
      ? (({children}) => <div>{children}</div>)
      : (({children}) => (
        <Panel style={{ paddingLeft: "15px" }}>
          <Panel.Body>
            {children}
          </Panel.Body>
        </Panel>
      ))

    if (entry.type == "c") {
      renderedEntry = (
        <Box>
          <li><b>{entry.username}</b> ({moment(entry.timestamp).format("HH:mm")}): {getText("Creado")} {getText(entry.col)} {getDocumentName(doc)}</li>
        </Box>
      )
    }

    else if (entry.type == "u") {
      const content = (
        keys(entry.changes)
          .filter(propName => !propsBlackList[propName])
          .map(propName => {
            const change = entry.changes[propName]
            if (isArray(change)) {
              return (
                <Change
                  entry={change}
                  previous={get(previous, ["changes", propName], [])}
                  propName={propName}
                  jsonDiffInstance={jsonDiffInstance}
                  Activities={Activities}
                  Cities={Cities}
                />
              )
            }
            else if (isObject(change) && !isArray(change) && keys(change).length > 0) {
              return (
                <Change
                  entry={[change]}
                  previous={[get(previous, ["changes", propName], {})]}
                  propName={propName}
                  jsonDiffInstance={jsonDiffInstance}
                  Activities={Activities}
                  Cities={Cities}
                />
              )
            }
            else if (!isEqual(change, previous && previous.changes[propName])) {
              if ((!previous || !previous.changes[propName]) && !isBoolean(change)) {
                return (
                  <li key={propName}>
                    {
                      getTextWithTokens(
                        isString(change) ? '$$ cambió a "$$"' : '$$ cambió a $$',
                        [getPropTranslation(propName) ? getText(getPropTranslation(propName)) : propName, change]
                      )
                    }
                  </li>
                )
              }
              else if (change && previous && change != previous.changes[propName]) {
                return renderModification(propName, change, previous.changes[propName])
              }
            }
          })
      )
      renderedEntry = (
        <Box>
          {
            this.props.compact
              ? content
              : (
                <li>
                  <b>{entry.username}</b> ({moment(entry.timestamp).format("HH:mm")}): {getText("Modificado")} {getText(entry.col)} {getDocumentName(doc)}:
                  <ul>{content}</ul>
                </li>
              )
          }
        </Box>
      )
    }

    else renderedEntry = (<span style={{fontWeight:600, color: "red"}}>WTF</span>)

    if (separador && !this.props.compact) return [separador, renderedEntry]
    else return renderedEntry

    // #TODO Show removal?
  }

  render() {
    if (!this.props.log) return <div>WTF</div>

    if (this.props.log.length == 0) return (
      <Panel bsStyle="warning">
        <Panel.Body>
          ⚠️  Log vacío
        </Panel.Body>
      </Panel>
    )

    return (
      <div>
        <ul>
          {
            true && this.props.log.map((entry, i, log) => (
              this.renderEntry(
                this.props.data[entry.col][entry.id],
                entry, i, log,
                this.props.data.activities, this.props.data.cities,
                this.jsonDiffInstance
              )
            ))
          }
        </ul>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  data: {
    trips: state.trips,
    cities: state.cities,
    activities: state.activities,
    routes: state.routes,
    reservations: state.reservations,
    tasks : state.tasks
  },
})

export default connect(mapStateToProps)(LogViewer)
